import { render, staticRenderFns } from "./UseStore.vue?vue&type=template&id=126dbad6"
import script from "./UseStore.vue?vue&type=script&lang=js"
export * from "./UseStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports